import { Link } from 'react-router-dom';

export default function EmailConfirmed() {
  return (
    <>
      <h2>Пошту підтверджено</h2>
      <Link to={'/'}>На головну</Link>
    </>
  );
}
